<template>
  <section class="section">
    <div class="container">
      <!-- berita -->
      <div class="row mt-4">
        <div class="col">
          <h2>
            <strong>Berita Terkini</strong>
          </h2>
        </div>
        <div class="col">
          <router-link to="/Berita" class="btn btn-success float-end">
            <i class="bi bi-eye"></i> Lihat Semua
          </router-link>
        </div>
      </div>

      <div class="row mb-4">
        <div v-for="news in newsList" :key="news.id" class="col-md-4 mt-4">
          <div class="card">
            <img :src="`http://bkpsdm.kendalkab.go.id/bahurekso/packages/photo/${news.fav}`" class="card-img-top" alt="..." />
            <div class="card-body">
              <h5 class="card-title">{{ news.titel }}</h5>
              <p class="card-text">{{ news.desc }}</p>
              <router-link :to="`/berita/${news.id}`" class="btn btn-success">Baca Selengkapnya</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
// import api from '@/services/api';

export default {
  name: "BeritaTerkini",
  data() {
    return {
      newsList: [],
      loading: true,
      error: null,

    };
  },
  methods: {

    async fetchNews() {
      try {
        const response = await axios.get(
          "/content/berita?pages=1&limit=3"
        );

        
        this.newsList = response.data.data;
        // console.log(response.data)
      } catch (err) {
        console.error(err);
        this.error = "Gagal memuat berita. Coba lagi nanti.";
      } finally {
        this.loading = false;
      }
    },
    formatDate(date) {
      const options = { year: "numeric", month: "long", day: "numeric" };
      return new Date(date).toLocaleDateString("id-ID", options);
    },
  },
  created() {
    this.fetchNews();
  },
};
</script>

<style></style>
